import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "listing-block" }
const _hoisted_2 = { class: "listing-block__inner" }

import ListingBlockHeader from '@/app/components/listing/ListingBlockHeader.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ListingBlockLayout',
  props: {
    title: {},
    viewAllLink: {},
    viewAllText: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(ListingBlockHeader, {
      to: __props.viewAllLink && { path: __props.viewAllLink },
      title: __props.title,
      viewAllText: __props.viewAllText
    }, _createSlots({ _: 2 }, [
      (_ctx.$slots.headerActions)
        ? {
            name: "default",
            fn: _withCtx(() => [
              _renderSlot(_ctx.$slots, "headerActions")
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["to", "title", "viewAllText"]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})